import React, { Component } from "react"
import { Helmet } from "react-helmet"
import { MetaData, structuredPageData } from "../../shared/structureData"
import { Redirect } from "react-router"
import * as imageAsset from "../../shared/images"
import AppContext from "../../shared/AppContext"
import "./vennmarketing.scss"

class EtrInsightsMarketing extends Component {
  constructor(props) {
    super(props)
    this.state = {
      image: ["image-1", "image-2", "image-3"],
    }
  }

  pageSEO = () => {
    let seo = {}
    seo.type = "website"
    seo.url = "https://app.etr.ai/etr-insights/search/about"
    seo.title = `ETR Insights Transcript Search | ETR`
    seo.image = imageAsset.defaultLogo
    seo.description =
      "Events and interviews that enhance Enterprise Technology Research's (ETR) CIO surveys and datasets. Search our library of featured IT executives and vendors."

    return (
      <Helmet>
        {MetaData(seo)}
        <script type="application/ld+json">
          {structuredPageData(seo.url)}
        </script>
      </Helmet>
    )
  }

  navigate = (url) => {
    this.props.history.push(url)
  }

  onLinkClicked = (e, description, from, openInquireModal) => {
    e.preventDefault()
    this.props.trackEvent(description, {
      from: from,
    })
    openInquireModal()
  }

  render() {
    if (!this.props.viewer || !this.props.viewer.isUserAuthenticated) {
      return (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: "/etr-insights/search/about" },
          }}
        />
      )
    }
    return (
      <AppContext.Consumer>
        {({ openInquireModal }) => {
          return (
            <section
              id="venn-landing"
              className={`${this.state.image[Math.floor(Math.random() * 3)]}`}
            >
              {this.pageSEO()}
              <div className="container">
                <img
                  className="top-pic"
                  src={imageAsset.etrWhiteInsightsLogo}
                />
                <h1 className="venn-marketing-text marketing-headers">
                  Transcription Search
                </h1>
                <h2 className="venn-marketing-text marketing-headers">
                  Exclusive Subscriber Feature
                </h2>
                <p className="venn-marketing-text venn-marketing-text-body">
                  Mine ETR Insights transcript database with full language
                  search functionality of expert interviews and events.
                </p>
                <img
                  className="screen-shot"
                  src={imageAsset.etrInsightsMarketing}
                />
                <div className="action-btns">
                  <div className="btn-with-cap">
                    <p className="venn-marketing-text">
                      Not yet a member of ETR Insights?
                    </p>
                    <span
                      onClick={(e) => {
                        this.onLinkClicked(
                          e,
                          "ETR Insights Contact Us Button",
                          "/etr-insights/search/about",
                          openInquireModal
                        )
                      }}
                      className="venn-marketing-text btn btn-light btn-outline"
                    >
                      Contact Us
                    </span>
                  </div>
                </div>
              </div>
            </section>
          )
        }}
      </AppContext.Consumer>
    )
  }
}
export default EtrInsightsMarketing
